function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { MagicPayloadMethod as e, RPCErrorCode as t, SDKErrorCode as r, SDKWarningCode as n, MagicOutgoingWindowMessage as o, MagicIncomingWindowMessage as i } from "@magic-sdk/types";

function s(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}

function a(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}

function c(e, t, r) {
  return t && a(e.prototype, t), r && a(e, r), e;
}

function u() {
  return (u = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function l(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, f(e, t);
}

function h(e) {
  return (h = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function f(e, t) {
  return (f = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function p() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function d(e, t, r) {
  return (d = p() ? Reflect.construct : function (e, t, r) {
    var n = [null];
    n.push.apply(n, t);
    var o = new (Function.bind.apply(e, n))();
    return r && f(o, r.prototype), o;
  }).apply(null, arguments);
}

function v(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return (v = function v(e) {
    if (null === e || -1 === Function.toString.call(e).indexOf("[native code]")) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, r);
    }

    function r() {
      return d(e, arguments, h(this).constructor);
    }

    return r.prototype = Object.create(e.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), f(r, e);
  })(e);
}

function E(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

s(function (e) {
  var t = function (e) {
    var t,
        r = Object.prototype,
        n = r.hasOwnProperty,
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        s = o.asyncIterator || "@@asyncIterator",
        a = o.toStringTag || "@@toStringTag";

    function c(e, t, r) {
      return Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), e[t];
    }

    try {
      c({}, "");
    } catch (e) {
      c = function c(e, t, r) {
        return e[t] = r;
      };
    }

    function u(e, t, r, n) {
      var o = Object.create((t && t.prototype instanceof E ? t : E).prototype),
          i = new T(n || []);
      return o._invoke = function (e, t, r) {
        var n = h;
        return function (o, i) {
          if (n === p) throw new Error("Generator is already running");

          if (n === d) {
            if ("throw" === o) throw i;
            return S();
          }

          for (r.method = o, r.arg = i;;) {
            var s = r.delegate;

            if (s) {
              var a = L(s, r);

              if (a) {
                if (a === v) continue;
                return a;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if (n === h) throw n = d, r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = p;
            var c = l(e, t, r);

            if ("normal" === c.type) {
              if (n = r.done ? d : f, c.arg === v) continue;
              return {
                value: c.arg,
                done: r.done
              };
            }

            "throw" === c.type && (n = d, r.method = "throw", r.arg = c.arg);
          }
        };
      }(e, r, i), o;
    }

    function l(e, t, r) {
      try {
        return {
          type: "normal",
          arg: e.call(t, r)
        };
      } catch (e) {
        return {
          type: "throw",
          arg: e
        };
      }
    }

    e.wrap = u;
    var h = "suspendedStart",
        f = "suspendedYield",
        p = "executing",
        d = "completed",
        v = {};

    function E() {}

    function m() {}

    function y() {}

    var g = {};
    c(g, i, function () {
      return this;
    });
    var I = Object.getPrototypeOf,
        w = I && I(I(P([])));
    w && w !== r && n.call(w, i) && (g = w);
    var R = y.prototype = E.prototype = Object.create(g);

    function O(e) {
      ["next", "throw", "return"].forEach(function (t) {
        c(e, t, function (e) {
          return this._invoke(t, e);
        });
      });
    }

    function _(e, t) {
      function r(o, i, s, a) {
        var c = l(e[o], e, i);

        if ("throw" !== c.type) {
          var u = c.arg,
              h = u.value;
          return h && "object" == _typeof(h) && n.call(h, "__await") ? t.resolve(h.__await).then(function (e) {
            r("next", e, s, a);
          }, function (e) {
            r("throw", e, s, a);
          }) : t.resolve(h).then(function (e) {
            u.value = e, s(u);
          }, function (e) {
            return r("throw", e, s, a);
          });
        }

        a(c.arg);
      }

      var o;

      this._invoke = function (e, n) {
        function i() {
          return new t(function (t, o) {
            r(e, n, t, o);
          });
        }

        return o = o ? o.then(i, i) : i();
      };
    }

    function L(e, r) {
      var n = e.iterator[r.method];

      if (n === t) {
        if (r.delegate = null, "throw" === r.method) {
          if (e.iterator.return && (r.method = "return", r.arg = t, L(e, r), "throw" === r.method)) return v;
          r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return v;
      }

      var o = l(n, e.iterator, r.arg);
      if ("throw" === o.type) return r.method = "throw", r.arg = o.arg, r.delegate = null, v;
      var i = o.arg;
      return i ? i.done ? (r[e.resultName] = i.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, v) : i : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, v);
    }

    function N(e) {
      var t = {
        tryLoc: e[0]
      };
      1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
    }

    function A(e) {
      var t = e.completion || {};
      t.type = "normal", delete t.arg, e.completion = t;
    }

    function T(e) {
      this.tryEntries = [{
        tryLoc: "root"
      }], e.forEach(N, this), this.reset(!0);
    }

    function P(e) {
      if (e) {
        var r = e[i];
        if (r) return r.call(e);
        if ("function" == typeof e.next) return e;

        if (!isNaN(e.length)) {
          var o = -1,
              s = function r() {
            for (; ++o < e.length;) {
              if (n.call(e, o)) return r.value = e[o], r.done = !1, r;
            }

            return r.value = t, r.done = !0, r;
          };

          return s.next = s;
        }
      }

      return {
        next: S
      };
    }

    function S() {
      return {
        value: t,
        done: !0
      };
    }

    return m.prototype = y, c(R, "constructor", y), c(y, "constructor", m), m.displayName = c(y, a, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
      var t = "function" == typeof e && e.constructor;
      return !!t && (t === m || "GeneratorFunction" === (t.displayName || t.name));
    }, e.mark = function (e) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, c(e, a, "GeneratorFunction")), e.prototype = Object.create(R), e;
    }, e.awrap = function (e) {
      return {
        __await: e
      };
    }, O(_.prototype), c(_.prototype, s, function () {
      return this;
    }), e.AsyncIterator = _, e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var s = new _(u(t, r, n, o), i);
      return e.isGeneratorFunction(r) ? s : s.next().then(function (e) {
        return e.done ? e.value : s.next();
      });
    }, O(R), c(R, a, "Generator"), c(R, i, function () {
      return this;
    }), c(R, "toString", function () {
      return "[object Generator]";
    }), e.keys = function (e) {
      var t = [];

      for (var r in e) {
        t.push(r);
      }

      return t.reverse(), function r() {
        for (; t.length;) {
          var n = t.pop();
          if (n in e) return r.value = n, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, e.values = P, T.prototype = {
      constructor: T,
      reset: function reset(e) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(A), !e) for (var r in this) {
          "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        }
      },
      stop: function stop() {
        this.done = !0;
        var e = this.tryEntries[0].completion;
        if ("throw" === e.type) throw e.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;

        function o(n, o) {
          return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var s = this.tryEntries[i],
              a = s.completion;
          if ("root" === s.tryLoc) return o("end");

          if (s.tryLoc <= this.prev) {
            var c = n.call(s, "catchLoc"),
                u = n.call(s, "finallyLoc");

            if (c && u) {
              if (this.prev < s.catchLoc) return o(s.catchLoc, !0);
              if (this.prev < s.finallyLoc) return o(s.finallyLoc);
            } else if (c) {
              if (this.prev < s.catchLoc) return o(s.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < s.finallyLoc) return o(s.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(e, t) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];

          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }

        i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
        var s = i ? i.completion : {};
        return s.type = e, s.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, v) : this.complete(s);
      },
      complete: function complete(e, t) {
        if ("throw" === e.type) throw e.arg;
        return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), v;
      },
      finish: function finish(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];
          if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), A(r), v;
        }
      },
      catch: function _catch(e) {
        for (var t = this.tryEntries.length - 1; t >= 0; --t) {
          var r = this.tryEntries[t];

          if (r.tryLoc === e) {
            var n = r.completion;

            if ("throw" === n.type) {
              var o = n.arg;
              A(r);
            }

            return o;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return this.delegate = {
          iterator: P(e),
          resultName: r,
          nextLoc: n
        }, "next" === this.method && (this.arg = t), v;
      }
    }, e;
  }(e.exports);

  try {
    regeneratorRuntime = t;
  } catch (e) {
    "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = t : Function("r", "regeneratorRuntime = r")(t);
  }
});

var m,
    y = {
  SEMVER_SPEC_VERSION: "2.0.0",
  MAX_LENGTH: 256,
  MAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER || 9007199254740991,
  MAX_SAFE_COMPONENT_LENGTH: 16
},
    g = "object" == (typeof process === "undefined" ? "undefined" : _typeof(process)) && process.env && process.env.NODE_DEBUG && /\bsemver\b/i.test(process.env.NODE_DEBUG) ? function () {
  var e;
  return (e = console).error.apply(e, ["SEMVER"].concat([].slice.call(arguments)));
} : function () {},
    I = (function (e, t) {
  var r = y.MAX_SAFE_COMPONENT_LENGTH,
      n = (t = e.exports = {}).re = [],
      o = t.src = [],
      i = t.t = {},
      s = 0,
      a = function a(e, t, r) {
    var a = s++;
    g(a, t), i[e] = a, o[a] = t, n[a] = new RegExp(t, r ? "g" : void 0);
  };

  a("NUMERICIDENTIFIER", "0|[1-9]\\d*"), a("NUMERICIDENTIFIERLOOSE", "[0-9]+"), a("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*"), a("MAINVERSION", "(" + o[i.NUMERICIDENTIFIER] + ")\\.(" + o[i.NUMERICIDENTIFIER] + ")\\.(" + o[i.NUMERICIDENTIFIER] + ")"), a("MAINVERSIONLOOSE", "(" + o[i.NUMERICIDENTIFIERLOOSE] + ")\\.(" + o[i.NUMERICIDENTIFIERLOOSE] + ")\\.(" + o[i.NUMERICIDENTIFIERLOOSE] + ")"), a("PRERELEASEIDENTIFIER", "(?:" + o[i.NUMERICIDENTIFIER] + "|" + o[i.NONNUMERICIDENTIFIER] + ")"), a("PRERELEASEIDENTIFIERLOOSE", "(?:" + o[i.NUMERICIDENTIFIERLOOSE] + "|" + o[i.NONNUMERICIDENTIFIER] + ")"), a("PRERELEASE", "(?:-(" + o[i.PRERELEASEIDENTIFIER] + "(?:\\." + o[i.PRERELEASEIDENTIFIER] + ")*))"), a("PRERELEASELOOSE", "(?:-?(" + o[i.PRERELEASEIDENTIFIERLOOSE] + "(?:\\." + o[i.PRERELEASEIDENTIFIERLOOSE] + ")*))"), a("BUILDIDENTIFIER", "[0-9A-Za-z-]+"), a("BUILD", "(?:\\+(" + o[i.BUILDIDENTIFIER] + "(?:\\." + o[i.BUILDIDENTIFIER] + ")*))"), a("FULLPLAIN", "v?" + o[i.MAINVERSION] + o[i.PRERELEASE] + "?" + o[i.BUILD] + "?"), a("FULL", "^" + o[i.FULLPLAIN] + "$"), a("LOOSEPLAIN", "[v=\\s]*" + o[i.MAINVERSIONLOOSE] + o[i.PRERELEASELOOSE] + "?" + o[i.BUILD] + "?"), a("LOOSE", "^" + o[i.LOOSEPLAIN] + "$"), a("GTLT", "((?:<|>)?=?)"), a("XRANGEIDENTIFIERLOOSE", o[i.NUMERICIDENTIFIERLOOSE] + "|x|X|\\*"), a("XRANGEIDENTIFIER", o[i.NUMERICIDENTIFIER] + "|x|X|\\*"), a("XRANGEPLAIN", "[v=\\s]*(" + o[i.XRANGEIDENTIFIER] + ")(?:\\.(" + o[i.XRANGEIDENTIFIER] + ")(?:\\.(" + o[i.XRANGEIDENTIFIER] + ")(?:" + o[i.PRERELEASE] + ")?" + o[i.BUILD] + "?)?)?"), a("XRANGEPLAINLOOSE", "[v=\\s]*(" + o[i.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + o[i.XRANGEIDENTIFIERLOOSE] + ")(?:\\.(" + o[i.XRANGEIDENTIFIERLOOSE] + ")(?:" + o[i.PRERELEASELOOSE] + ")?" + o[i.BUILD] + "?)?)?"), a("XRANGE", "^" + o[i.GTLT] + "\\s*" + o[i.XRANGEPLAIN] + "$"), a("XRANGELOOSE", "^" + o[i.GTLT] + "\\s*" + o[i.XRANGEPLAINLOOSE] + "$"), a("COERCE", "(^|[^\\d])(\\d{1," + r + "})(?:\\.(\\d{1," + r + "}))?(?:\\.(\\d{1," + r + "}))?(?:$|[^\\d])"), a("COERCERTL", o[i.COERCE], !0), a("LONETILDE", "(?:~>?)"), a("TILDETRIM", "(\\s*)" + o[i.LONETILDE] + "\\s+", !0), t.tildeTrimReplace = "$1~", a("TILDE", "^" + o[i.LONETILDE] + o[i.XRANGEPLAIN] + "$"), a("TILDELOOSE", "^" + o[i.LONETILDE] + o[i.XRANGEPLAINLOOSE] + "$"), a("LONECARET", "(?:\\^)"), a("CARETTRIM", "(\\s*)" + o[i.LONECARET] + "\\s+", !0), t.caretTrimReplace = "$1^", a("CARET", "^" + o[i.LONECARET] + o[i.XRANGEPLAIN] + "$"), a("CARETLOOSE", "^" + o[i.LONECARET] + o[i.XRANGEPLAINLOOSE] + "$"), a("COMPARATORLOOSE", "^" + o[i.GTLT] + "\\s*(" + o[i.LOOSEPLAIN] + ")$|^$"), a("COMPARATOR", "^" + o[i.GTLT] + "\\s*(" + o[i.FULLPLAIN] + ")$|^$"), a("COMPARATORTRIM", "(\\s*)" + o[i.GTLT] + "\\s*(" + o[i.LOOSEPLAIN] + "|" + o[i.XRANGEPLAIN] + ")", !0), t.comparatorTrimReplace = "$1$2$3", a("HYPHENRANGE", "^\\s*(" + o[i.XRANGEPLAIN] + ")\\s+-\\s+(" + o[i.XRANGEPLAIN] + ")\\s*$"), a("HYPHENRANGELOOSE", "^\\s*(" + o[i.XRANGEPLAINLOOSE] + ")\\s+-\\s+(" + o[i.XRANGEPLAINLOOSE] + ")\\s*$"), a("STAR", "(<|>)?=?\\s*\\*"), a("GTE0", "^\\s*>=\\s*0.0.0\\s*$"), a("GTE0PRE", "^\\s*>=\\s*0.0.0-0\\s*$");
}(m = {
  exports: {}
}, m.exports), m.exports),
    w = /^[0-9]+$/,
    R = y.MAX_LENGTH,
    O = y.MAX_SAFE_INTEGER,
    _ = I.re,
    L = I.t,
    N = function N(e, t) {
  var r = w.test(e),
      n = w.test(t);
  return r && n && (e = +e, t = +t), e === t ? 0 : r && !n ? -1 : n && !r ? 1 : e < t ? -1 : 1;
},
    A = function () {
  function e(t, r) {
    if (r && "object" == _typeof(r) || (r = {
      loose: !!r,
      includePrerelease: !1
    }), t instanceof e) {
      if (t.loose === !!r.loose && t.includePrerelease === !!r.includePrerelease) return t;
      t = t.version;
    } else if ("string" != typeof t) throw new TypeError("Invalid Version: " + t);

    if (t.length > R) throw new TypeError("version is longer than " + R + " characters");
    g("SemVer", t, r), this.options = r, this.loose = !!r.loose, this.includePrerelease = !!r.includePrerelease;
    var n = t.trim().match(r.loose ? _[L.LOOSE] : _[L.FULL]);
    if (!n) throw new TypeError("Invalid Version: " + t);
    if (this.raw = t, this.major = +n[1], this.minor = +n[2], this.patch = +n[3], this.major > O || this.major < 0) throw new TypeError("Invalid major version");
    if (this.minor > O || this.minor < 0) throw new TypeError("Invalid minor version");
    if (this.patch > O || this.patch < 0) throw new TypeError("Invalid patch version");
    this.prerelease = n[4] ? n[4].split(".").map(function (e) {
      if (/^[0-9]+$/.test(e)) {
        var t = +e;
        if (t >= 0 && t < O) return t;
      }

      return e;
    }) : [], this.build = n[5] ? n[5].split(".") : [], this.format();
  }

  var t = e.prototype;
  return t.format = function () {
    return this.version = this.major + "." + this.minor + "." + this.patch, this.prerelease.length && (this.version += "-" + this.prerelease.join(".")), this.version;
  }, t.toString = function () {
    return this.version;
  }, t.compare = function (t) {
    if (g("SemVer.compare", this.version, this.options, t), !(t instanceof e)) {
      if ("string" == typeof t && t === this.version) return 0;
      t = new e(t, this.options);
    }

    return t.version === this.version ? 0 : this.compareMain(t) || this.comparePre(t);
  }, t.compareMain = function (t) {
    return t instanceof e || (t = new e(t, this.options)), N(this.major, t.major) || N(this.minor, t.minor) || N(this.patch, t.patch);
  }, t.comparePre = function (t) {
    if (t instanceof e || (t = new e(t, this.options)), this.prerelease.length && !t.prerelease.length) return -1;
    if (!this.prerelease.length && t.prerelease.length) return 1;
    if (!this.prerelease.length && !t.prerelease.length) return 0;
    var r = 0;

    do {
      var n = this.prerelease[r],
          o = t.prerelease[r];
      if (g("prerelease compare", r, n, o), void 0 === n && void 0 === o) return 0;
      if (void 0 === o) return 1;
      if (void 0 === n) return -1;
      if (n !== o) return N(n, o);
    } while (++r);
  }, t.compareBuild = function (t) {
    t instanceof e || (t = new e(t, this.options));
    var r = 0;

    do {
      var n = this.build[r],
          o = t.build[r];
      if (g("prerelease compare", r, n, o), void 0 === n && void 0 === o) return 0;
      if (void 0 === o) return 1;
      if (void 0 === n) return -1;
      if (n !== o) return N(n, o);
    } while (++r);
  }, t.inc = function (e, t) {
    switch (e) {
      case "premajor":
        this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", t);
        break;

      case "preminor":
        this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", t);
        break;

      case "prepatch":
        this.prerelease.length = 0, this.inc("patch", t), this.inc("pre", t);
        break;

      case "prerelease":
        0 === this.prerelease.length && this.inc("patch", t), this.inc("pre", t);
        break;

      case "major":
        0 === this.minor && 0 === this.patch && 0 !== this.prerelease.length || this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
        break;

      case "minor":
        0 === this.patch && 0 !== this.prerelease.length || this.minor++, this.patch = 0, this.prerelease = [];
        break;

      case "patch":
        0 === this.prerelease.length && this.patch++, this.prerelease = [];
        break;

      case "pre":
        if (0 === this.prerelease.length) this.prerelease = [0];else {
          for (var r = this.prerelease.length; --r >= 0;) {
            "number" == typeof this.prerelease[r] && (this.prerelease[r]++, r = -2);
          }

          -1 === r && this.prerelease.push(0);
        }
        t && (this.prerelease[0] === t ? isNaN(this.prerelease[1]) && (this.prerelease = [t, 0]) : this.prerelease = [t, 0]);
        break;

      default:
        throw new Error("invalid increment argument: " + e);
    }

    return this.format(), this.raw = this.version, this;
  }, e;
}(),
    T = function T(e, t, r) {
  return new A(e, r).compare(new A(t, r));
},
    P = function P(e, t, r, n) {
  switch (t) {
    case "===":
      return "object" == _typeof(e) && (e = e.version), "object" == _typeof(r) && (r = r.version), e === r;

    case "!==":
      return "object" == _typeof(e) && (e = e.version), "object" == _typeof(r) && (r = r.version), e !== r;

    case "":
    case "=":
    case "==":
      return function (e, t, r) {
        return 0 === T(e, t, r);
      }(e, r, n);

    case "!=":
      return function (e, t, r) {
        return 0 !== T(e, t, r);
      }(e, r, n);

    case ">":
      return function (e, t, r) {
        return T(e, t, r) > 0;
      }(e, r, n);

    case ">=":
      return function (e, t, r) {
        return T(e, t, r) >= 0;
      }(e, r, n);

    case "<":
      return function (e, t, r) {
        return T(e, t, r) < 0;
      }(e, r, n);

    case "<=":
      return function (e, t, r) {
        return T(e, t, r) <= 0;
      }(e, r, n);

    default:
      throw new TypeError("Invalid operator: " + t);
  }
},
    S = Symbol("SemVer ANY"),
    b = function () {
  function e(t, r) {
    if (r && "object" == _typeof(r) || (r = {
      loose: !!r,
      includePrerelease: !1
    }), t instanceof e) {
      if (t.loose === !!r.loose) return t;
      t = t.value;
    }

    g("comparator", t, r), this.options = r, this.loose = !!r.loose, this.parse(t), this.value = this.semver === S ? "" : this.operator + this.semver.version, g("comp", this);
  }

  var t = e.prototype;
  return t.parse = function (e) {
    var t = e.match(this.options.loose ? M[j.COMPARATORLOOSE] : M[j.COMPARATOR]);
    if (!t) throw new TypeError("Invalid comparator: " + e);
    this.operator = void 0 !== t[1] ? t[1] : "", "=" === this.operator && (this.operator = ""), this.semver = t[2] ? new A(t[2], this.options.loose) : S;
  }, t.toString = function () {
    return this.value;
  }, t.test = function (e) {
    if (g("Comparator.test", e, this.options.loose), this.semver === S || e === S) return !0;
    if ("string" == typeof e) try {
      e = new A(e, this.options);
    } catch (e) {
      return !1;
    }
    return P(e, this.operator, this.semver, this.options);
  }, t.intersects = function (t, r) {
    if (!(t instanceof e)) throw new TypeError("a Comparator is required");
    if (r && "object" == _typeof(r) || (r = {
      loose: !!r,
      includePrerelease: !1
    }), "" === this.operator) return "" === this.value || new C(t.value, r).test(this.value);
    if ("" === t.operator) return "" === t.value || new C(this.value, r).test(t.semver);
    var n = !(">=" !== this.operator && ">" !== this.operator || ">=" !== t.operator && ">" !== t.operator),
        o = !("<=" !== this.operator && "<" !== this.operator || "<=" !== t.operator && "<" !== t.operator),
        i = this.semver.version === t.semver.version,
        s = !(">=" !== this.operator && "<=" !== this.operator || ">=" !== t.operator && "<=" !== t.operator),
        a = P(this.semver, "<", t.semver, r) && (">=" === this.operator || ">" === this.operator) && ("<=" === t.operator || "<" === t.operator),
        c = P(this.semver, ">", t.semver, r) && ("<=" === this.operator || "<" === this.operator) && (">=" === t.operator || ">" === t.operator);
    return n || o || i && s || a || c;
  }, c(e, null, [{
    key: "ANY",
    get: function get() {
      return S;
    }
  }]), e;
}(),
    M = I.re,
    j = I.t,
    C = function () {
  function e(t, r) {
    var n = this;
    if (r && "object" == _typeof(r) || (r = {
      loose: !!r,
      includePrerelease: !1
    }), t instanceof e) return t.loose === !!r.loose && t.includePrerelease === !!r.includePrerelease ? t : new e(t.raw, r);
    if (t instanceof b) return this.raw = t.value, this.set = [[t]], this.format(), this;
    if (this.options = r, this.loose = !!r.loose, this.includePrerelease = !!r.includePrerelease, this.raw = t, this.set = t.split(/\s*\|\|\s*/).map(function (e) {
      return n.parseRange(e.trim());
    }).filter(function (e) {
      return e.length;
    }), !this.set.length) throw new TypeError("Invalid SemVer Range: " + t);
    this.format();
  }

  var t = e.prototype;
  return t.format = function () {
    return this.range = this.set.map(function (e) {
      return e.join(" ").trim();
    }).join("||").trim(), this.range;
  }, t.toString = function () {
    return this.range;
  }, t.parseRange = function (e) {
    var t = this,
        r = this.options.loose;
    e = (e = e.trim()).replace(r ? x[k.HYPHENRANGELOOSE] : x[k.HYPHENRANGE], J(this.options.includePrerelease)), g("hyphen replace", e), e = e.replace(x[k.COMPARATORTRIM], D), g("comparator trim", e, x[k.COMPARATORTRIM]), e = (e = (e = e.replace(x[k.TILDETRIM], G)).replace(x[k.CARETTRIM], F)).split(/\s+/).join(" ");
    var n = r ? x[k.COMPARATORLOOSE] : x[k.COMPARATOR];
    return e.split(" ").map(function (e) {
      return X(e, t.options);
    }).join(" ").split(/\s+/).map(function (e) {
      return z(e, t.options);
    }).filter(this.options.loose ? function (e) {
      return !!e.match(n);
    } : function () {
      return !0;
    }).map(function (e) {
      return new b(e, t.options);
    });
  }, t.intersects = function (t, r) {
    if (!(t instanceof e)) throw new TypeError("a Range is required");
    return this.set.some(function (e) {
      return U(e, r) && t.set.some(function (t) {
        return U(t, r) && e.every(function (e) {
          return t.every(function (t) {
            return e.intersects(t, r);
          });
        });
      });
    });
  }, t.test = function (e) {
    if (!e) return !1;
    if ("string" == typeof e) try {
      e = new A(e, this.options);
    } catch (e) {
      return !1;
    }

    for (var t = 0; t < this.set.length; t++) {
      if (Q(this.set[t], e, this.options)) return !0;
    }

    return !1;
  }, e;
}(),
    x = I.re,
    k = I.t,
    D = I.comparatorTrimReplace,
    G = I.tildeTrimReplace,
    F = I.caretTrimReplace,
    U = function U(e, t) {
  for (var r = !0, n = e.slice(), o = n.pop(); r && n.length;) {
    r = n.every(function (e) {
      return o.intersects(e, t);
    }), o = n.pop();
  }

  return r;
},
    X = function X(e, t) {
  return g("comp", e, t), e = q(e, t), g("caret", e), e = V(e, t), g("tildes", e), e = W(e, t), g("xrange", e), e = Y(e, t), g("stars", e), e;
},
    H = function H(e) {
  return !e || "x" === e.toLowerCase() || "*" === e;
},
    V = function V(e, t) {
  return e.trim().split(/\s+/).map(function (e) {
    return $(e, t);
  }).join(" ");
},
    $ = function $(e, t) {
  return e.replace(t.loose ? x[k.TILDELOOSE] : x[k.TILDE], function (t, r, n, o, i) {
    var s;
    return g("tilde", e, t, r, n, o, i), H(r) ? s = "" : H(n) ? s = ">=" + r + ".0.0 <" + (+r + 1) + ".0.0-0" : H(o) ? s = ">=" + r + "." + n + ".0 <" + r + "." + (+n + 1) + ".0-0" : i ? (g("replaceTilde pr", i), s = ">=" + r + "." + n + "." + o + "-" + i + " <" + r + "." + (+n + 1) + ".0-0") : s = ">=" + r + "." + n + "." + o + " <" + r + "." + (+n + 1) + ".0-0", g("tilde return", s), s;
  });
},
    q = function q(e, t) {
  return e.trim().split(/\s+/).map(function (e) {
    return K(e, t);
  }).join(" ");
},
    K = function K(e, t) {
  g("caret", e, t);
  var r = t.includePrerelease ? "-0" : "";
  return e.replace(t.loose ? x[k.CARETLOOSE] : x[k.CARET], function (t, n, o, i, s) {
    var a;
    return g("caret", e, t, n, o, i, s), H(n) ? a = "" : H(o) ? a = ">=" + n + ".0.0" + r + " <" + (+n + 1) + ".0.0-0" : H(i) ? a = "0" === n ? ">=" + n + "." + o + ".0" + r + " <" + n + "." + (+o + 1) + ".0-0" : ">=" + n + "." + o + ".0" + r + " <" + (+n + 1) + ".0.0-0" : s ? (g("replaceCaret pr", s), a = "0" === n ? "0" === o ? ">=" + n + "." + o + "." + i + "-" + s + " <" + n + "." + o + "." + (+i + 1) + "-0" : ">=" + n + "." + o + "." + i + "-" + s + " <" + n + "." + (+o + 1) + ".0-0" : ">=" + n + "." + o + "." + i + "-" + s + " <" + (+n + 1) + ".0.0-0") : (g("no pr"), a = "0" === n ? "0" === o ? ">=" + n + "." + o + "." + i + r + " <" + n + "." + o + "." + (+i + 1) + "-0" : ">=" + n + "." + o + "." + i + r + " <" + n + "." + (+o + 1) + ".0-0" : ">=" + n + "." + o + "." + i + " <" + (+n + 1) + ".0.0-0"), g("caret return", a), a;
  });
},
    W = function W(e, t) {
  return g("replaceXRanges", e, t), e.split(/\s+/).map(function (e) {
    return B(e, t);
  }).join(" ");
},
    B = function B(e, t) {
  return (e = e.trim()).replace(t.loose ? x[k.XRANGELOOSE] : x[k.XRANGE], function (r, n, o, i, s, a) {
    g("xRange", e, r, n, o, i, s, a);
    var c = H(o),
        u = c || H(i),
        l = u || H(s);
    return "=" === n && l && (n = ""), a = t.includePrerelease ? "-0" : "", c ? r = ">" === n || "<" === n ? "<0.0.0-0" : "*" : n && l ? (u && (i = 0), s = 0, ">" === n ? (n = ">=", u ? (o = +o + 1, i = 0, s = 0) : (i = +i + 1, s = 0)) : "<=" === n && (n = "<", u ? o = +o + 1 : i = +i + 1), "<" === n && (a = "-0"), r = n + o + "." + i + "." + s + a) : u ? r = ">=" + o + ".0.0" + a + " <" + (+o + 1) + ".0.0-0" : l && (r = ">=" + o + "." + i + ".0" + a + " <" + o + "." + (+i + 1) + ".0-0"), g("xRange return", r), r;
  });
},
    Y = function Y(e, t) {
  return g("replaceStars", e, t), e.trim().replace(x[k.STAR], "");
},
    z = function z(e, t) {
  return g("replaceGTE0", e, t), e.trim().replace(x[t.includePrerelease ? k.GTE0PRE : k.GTE0], "");
},
    J = function J(e) {
  return function (t, r, n, o, i, s, a, c, u, l, h, f, p) {
    return ((r = H(n) ? "" : H(o) ? ">=" + n + ".0.0" + (e ? "-0" : "") : H(i) ? ">=" + n + "." + o + ".0" + (e ? "-0" : "") : s ? ">=" + r : ">=" + r + (e ? "-0" : "")) + " " + (c = H(u) ? "" : H(l) ? "<" + (+u + 1) + ".0.0-0" : H(h) ? "<" + u + "." + (+l + 1) + ".0-0" : f ? "<=" + u + "." + l + "." + h + "-" + f : e ? "<" + u + "." + l + "." + (+h + 1) + "-0" : "<=" + c)).trim();
  };
},
    Q = function Q(e, t, r) {
  for (var n = 0; n < e.length; n++) {
    if (!e[n].test(t)) return !1;
  }

  if (t.prerelease.length && !r.includePrerelease) {
    for (var o = 0; o < e.length; o++) {
      if (g(e[o].semver), e[o].semver !== b.ANY && e[o].semver.prerelease.length > 0) {
        var i = e[o].semver;
        if (i.major === t.major && i.minor === t.minor && i.patch === t.patch) return !0;
      }
    }

    return !1;
  }

  return !0;
},
    Z = y.MAX_LENGTH,
    ee = I.re,
    te = I.t,
    re = I.re,
    ne = I.t;

function oe(e) {
  return String.fromCharCode(parseInt(e.slice(1), 16));
}

function ie(e) {
  return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
}

function se(e) {
  return t = JSON.stringify(e), btoa(encodeURIComponent(t).replace(/%[0-9A-F]{2}/g, oe));
  var t;
}

function ae(e) {
  return JSON.parse(decodeURIComponent(Array.from(atob(e), ie).join("")));
}

function ce(e) {
  return void 0 === e;
}

function ue(e) {
  return function (e) {
    return null === e;
  }(e) || ce(e);
}

function le(e) {
  return !ue(e) && !(ce(e.jsonrpc) || ce(e.id) || ce(e.method) || ce(e.params));
}

function he(e) {
  return !ue(e) && !(ce(e.jsonrpc) || ce(e.id) || ce(e.result) && ce(e.error));
}

function fe(t) {
  return !ue(t) && "string" == typeof t && Object.values(e).includes(t);
}

function pe(e) {
  return !ue(e) && "number" == typeof e && Object.values(t).includes(e);
}

function de(e) {
  if (!e) return !0;

  for (var t in e) {
    if (Object.hasOwnProperty.call(e, t)) return !1;
  }

  return !0;
}

var ve = {};

function Ee(e, t) {
  return Object.assign(ve, t), e;
}

var me = {
  "magic-sdk": "magic-sdk",
  "@magic-sdk/react-native": "magic-sdk-rn"
},
    ye = function (e) {
  function t(r, n) {
    var o;
    return (o = e.call(this, "Magic SDK Error: [" + r + "] " + n) || this).code = void 0, o.rawMessage = void 0, o.__proto__ = Error, o.code = r, o.rawMessage = n, Object.setPrototypeOf(E(o), t.prototype), o;
  }

  return l(t, e), t;
}(v(Error)),
    ge = function (e) {
  function r(n) {
    var o;
    (o = e.call(this) || this).__proto__ = Error, o.code = void 0, o.rawMessage = void 0;
    var i = Number(null == n ? void 0 : n.code);
    return o.rawMessage = (null == n ? void 0 : n.message) || "Internal error", o.code = pe(i) ? i : t.InternalError, o.message = "Magic RPC Error: [" + o.code + "] " + o.rawMessage, Object.setPrototypeOf(E(o), r.prototype), o;
  }

  return l(r, e), r;
}(v(Error)),
    Ie = function () {
  function e(e, t) {
    this.code = void 0, this.rawMessage = void 0, this.message = void 0, this.code = e, this.rawMessage = t, this.message = "Magic SDK Warning: [" + e + "] " + t;
  }

  return e.prototype.log = function () {
    console.warn(this.message);
  }, e;
}(),
    we = function (e) {
  function t(r, n, o, i) {
    var s;
    return (s = e.call(this, "Magic Extension Error (" + r.name + "): [" + n + "] " + o) || this).code = void 0, s.rawMessage = void 0, s.data = void 0, s.__proto__ = Error, s.code = n, s.rawMessage = o, s.data = i, Object.setPrototypeOf(E(s), t.prototype), s;
  }

  return l(t, e), t;
}(v(Error)),
    Re = function () {
  function e(e, t, r) {
    this.code = void 0, this.rawMessage = void 0, this.message = void 0, this.code = t, this.rawMessage = r, this.message = "Magic Extension Warning (" + e.name + "): [" + t + "] " + r;
  }

  return e.prototype.log = function () {
    console.warn(this.message);
  }, e;
}();

function Oe() {
  return new ye(r.MissingApiKey, "Please provide an API key that you acquired from the Magic developer dashboard.");
}

function _e() {
  return new ye(r.ModalNotReady, "Modal is not ready.");
}

function Le() {
  return new ye(r.MalformedResponse, "Response from the Magic iframe is malformed.");
}

function Ne(e) {
  return new ye(r.ExtensionNotInitialized, "Extensions must be initialized with a Magic SDK instance before `Extension." + e + "` can be accessed. Do not invoke `Extension." + e + "` inside an extension constructor.");
}

function Ae(e) {
  var t = "Some extensions are incompatible with `" + ve.sdkName + "@" + ve.version + "`:";
  return e.filter(function (e) {
    return null != e.compat;
  }).forEach(function (e) {
    var r = e.compat[ve.sdkName];
    "string" == typeof r ? t += "\n  - Extension `" + e.name + "` supports version(s) `" + r + "`" : r || (t += "\n  - Extension `" + e.name + "` does not support " + ve.platform + " environments.");
  }), new ye(r.IncompatibleExtensions, t);
}

function Te(e) {
  var t, n, o;
  return new ye(r.InvalidArgument, "Invalid " + (o = (t = e.argument + 1) % 100, (1 == (n = t % 10) && 11 !== o ? t + "st" : 2 === n && 12 !== o ? t + "nd" : 3 === n && 13 !== o ? t + "rd" : t + "th") + " argument given to `") + e.procedure + "`.\n  Expected: `" + e.expected + "`\n  Received: `" + e.received + "`");
}

function Pe() {
  return new Ie(n.DuplicateIframe, "Duplicate iframes found.");
}

function Se() {
  return new Ie(n.SyncWeb3Method, "Non-async web3 methods are deprecated in web3 > 1.0 and are not supported by the Magic web3 provider. Please use an async method instead.");
}

function be() {
  return new Ie(n.ReactNativeEndpointConfiguration, "CUSTOM DOMAINS ARE NOT SUPPORTED WHEN USING MAGIC SDK WITH REACT NATIVE! The `endpoint` parameter SHOULD NOT be provided. The Magic `<iframe>` is automatically wrapped by a WebView pointed at `" + ve.defaultEndpoint + "`. Changing this default behavior will lead to unexpected results and potentially security-threatening bugs.");
}

function Me(e) {
  var t = e.useInstead;
  return new Ie(n.DeprecationNotice, "`" + e.method + "` will be removed from `" + ve.sdkName + "` in version `" + e.removalVersions[ve.sdkName] + "`." + (t ? " Use `" + t + "` instead." : ""));
}

var je = _regeneratorRuntime().mark(Ce);

function Ce() {
  var e;
  return _regeneratorRuntime().wrap(function (t) {
    for (;;) {
      switch (t.prev = t.next) {
        case 0:
          e = 0;

        case 1:
          if (!(e < Number.MAX_SAFE_INTEGER)) {
            t.next = 7;
            break;
          }

          return t.next = 5, ++e;

        case 5:
          t.next = 8;
          break;

        case 7:
          e = 0;

        case 8:
          t.next = 1;
          break;

        case 10:
        case "end":
          return t.stop();
      }
    }
  }, je);
}

var xe = Ce();

function ke() {
  return xe.next().value;
}

var De = Symbol("Payload pre-processed by Magic SDK");

function Ge(e) {
  return Object.defineProperty(e, De, {
    value: !0,
    enumerable: !1
  }), e;
}

function Fe(e) {
  var t, r, n;
  return function (e) {
    return !!e[De];
  }(e) || (e.jsonrpc = null != (t = e.jsonrpc) ? t : "2.0", e.id = ke(), e.method = null != (r = e.method) ? r : "noop", e.params = null != (n = e.params) ? n : [], Ge(e)), e;
}

function Ue(e, t) {
  return void 0 === t && (t = []), Ge({
    params: t,
    method: e,
    jsonrpc: "2.0",
    id: ke()
  });
}

var Xe = function () {
  function e(t) {
    this._jsonrpc = void 0, this._id = void 0, this._result = void 0, this._error = void 0, t instanceof e ? (this._jsonrpc = t.payload.jsonrpc, this._id = t.payload.id, this._result = t.payload.result, this._error = t.payload.error) : he(t) ? (this._jsonrpc = t.jsonrpc, this._id = t.id, this._result = t.result, this._error = t.error) : (this._jsonrpc = t.jsonrpc, this._id = t.id, this._result = void 0, this._error = void 0);
  }

  var t = e.prototype;
  return t.applyError = function (e) {
    return this._error = e, this;
  }, t.applyResult = function (e) {
    return this._result = e, this;
  }, c(e, [{
    key: "hasError",
    get: function get() {
      return null != this._error;
    }
  }, {
    key: "hasResult",
    get: function get() {
      return void 0 !== this._result;
    }
  }, {
    key: "payload",
    get: function get() {
      return {
        jsonrpc: this._jsonrpc,
        id: this._id,
        result: this._result,
        error: this._error
      };
    }
  }]), e;
}(),
    He = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }

  return l(t, e), t;
}(s(function (e) {
  var t = Object.prototype.hasOwnProperty,
      r = "~";

  function n() {}

  function o(e, t, r) {
    this.fn = e, this.context = t, this.once = r || !1;
  }

  function i(e, t, n, i, s) {
    if ("function" != typeof n) throw new TypeError("The listener must be a function");
    var a = new o(n, i || e, s),
        c = r ? r + t : t;
    return e._events[c] ? e._events[c].fn ? e._events[c] = [e._events[c], a] : e._events[c].push(a) : (e._events[c] = a, e._eventsCount++), e;
  }

  function s(e, t) {
    0 == --e._eventsCount ? e._events = new n() : delete e._events[t];
  }

  function a() {
    this._events = new n(), this._eventsCount = 0;
  }

  Object.create && (n.prototype = Object.create(null), new n().__proto__ || (r = !1)), a.prototype.eventNames = function () {
    var e,
        n,
        o = [];
    if (0 === this._eventsCount) return o;

    for (n in e = this._events) {
      t.call(e, n) && o.push(r ? n.slice(1) : n);
    }

    return Object.getOwnPropertySymbols ? o.concat(Object.getOwnPropertySymbols(e)) : o;
  }, a.prototype.listeners = function (e) {
    var t = this._events[r ? r + e : e];
    if (!t) return [];
    if (t.fn) return [t.fn];

    for (var n = 0, o = t.length, i = new Array(o); n < o; n++) {
      i[n] = t[n].fn;
    }

    return i;
  }, a.prototype.listenerCount = function (e) {
    var t = this._events[r ? r + e : e];
    return t ? t.fn ? 1 : t.length : 0;
  }, a.prototype.emit = function (e, t, n, o, i, s) {
    var a = r ? r + e : e;
    if (!this._events[a]) return !1;
    var c,
        u,
        l = this._events[a],
        h = arguments.length;

    if (l.fn) {
      switch (l.once && this.removeListener(e, l.fn, void 0, !0), h) {
        case 1:
          return l.fn.call(l.context), !0;

        case 2:
          return l.fn.call(l.context, t), !0;

        case 3:
          return l.fn.call(l.context, t, n), !0;

        case 4:
          return l.fn.call(l.context, t, n, o), !0;

        case 5:
          return l.fn.call(l.context, t, n, o, i), !0;

        case 6:
          return l.fn.call(l.context, t, n, o, i, s), !0;
      }

      for (u = 1, c = new Array(h - 1); u < h; u++) {
        c[u - 1] = arguments[u];
      }

      l.fn.apply(l.context, c);
    } else {
      var f,
          p = l.length;

      for (u = 0; u < p; u++) {
        switch (l[u].once && this.removeListener(e, l[u].fn, void 0, !0), h) {
          case 1:
            l[u].fn.call(l[u].context);
            break;

          case 2:
            l[u].fn.call(l[u].context, t);
            break;

          case 3:
            l[u].fn.call(l[u].context, t, n);
            break;

          case 4:
            l[u].fn.call(l[u].context, t, n, o);
            break;

          default:
            if (!c) for (f = 1, c = new Array(h - 1); f < h; f++) {
              c[f - 1] = arguments[f];
            }
            l[u].fn.apply(l[u].context, c);
        }
      }
    }

    return !0;
  }, a.prototype.on = function (e, t, r) {
    return i(this, e, t, r, !1);
  }, a.prototype.once = function (e, t, r) {
    return i(this, e, t, r, !0);
  }, a.prototype.removeListener = function (e, t, n, o) {
    var i = r ? r + e : e;
    if (!this._events[i]) return this;
    if (!t) return s(this, i), this;
    var a = this._events[i];
    if (a.fn) a.fn !== t || o && !a.once || n && a.context !== n || s(this, i);else {
      for (var c = 0, u = [], l = a.length; c < l; c++) {
        (a[c].fn !== t || o && !a[c].once || n && a[c].context !== n) && u.push(a[c]);
      }

      u.length ? this._events[i] = 1 === u.length ? u[0] : u : s(this, i);
    }
    return this;
  }, a.prototype.removeAllListeners = function (e) {
    var t;
    return e ? this._events[t = r ? r + e : e] && s(this, t) : (this._events = new n(), this._eventsCount = 0), this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = r, a.EventEmitter = a, e.exports = a;
}));

function Ve() {
  var e = new He();
  return {
    emitter: e,
    createChainingEmitterMethod: function createChainingEmitterMethod(t, r) {
      return function () {
        return e[t].apply(e, [].slice.call(arguments)), r;
      };
    },
    createBoundEmitterMethod: function createBoundEmitterMethod(t) {
      return function () {
        return e[t].apply(e, [].slice.call(arguments));
      };
    }
  };
}

var $e = Symbol("isPromiEvent");

function qe(e) {
  return !!e[$e];
}

function Ke(e) {
  var t = We(e),
      r = Ve(),
      n = r.createBoundEmitterMethod,
      o = r.createChainingEmitterMethod,
      i = Symbol("Promise.then"),
      s = Symbol("Promise.catch"),
      a = Symbol("Promise.finally"),
      c = function c(e, t) {
    return function () {
      var r = t[e].apply(t, [].slice.call(arguments));
      return u(r);
    };
  },
      u = function u(e) {
    var t;
    return Object.assign(e, ((t = {})[$e] = !0, t[i] = e[i] || e.then, t[s] = e[s] || e.catch, t[a] = e[a] || e.finally, t.then = c(i, e), t.catch = c(s, e), t.finally = c(a, e), t.on = o("on", e), t.once = o("once", e), t.addListener = o("addListener", e), t.off = o("off", e), t.removeListener = o("removeListener", e), t.removeAllListeners = o("removeAllListeners", e), t.emit = n("emit"), t.eventNames = n("eventNames"), t.listeners = n("listeners"), t.listenerCount = n("listenerCount"), t));
  },
      l = u(t.then(function (e) {
    return l.emit("done", e), l.emit("settled"), e;
  }, function (e) {
    throw l.emit("error", e), l.emit("settled"), e;
  }));

  return l;
}

function We(e) {
  return new Promise(function (t, r) {
    var n = e(t, r);
    Promise.resolve(n).catch(r);
  });
}

var Be,
    Ye = function () {
  function e(e) {
    this.sdk = void 0, this.sdk = e;
  }

  return e.prototype.request = function (e) {
    var t = this.overlay.post(o.MAGIC_HANDLE_REQUEST, Fe(e)),
        r = Ke(function (e, r) {
      t.then(function (t) {
        if (n(), t.hasError) r(new ge(t.payload.error));else {
          if (!t.hasResult) throw Le();
          e(t.payload.result);
        }
      }).catch(function (e) {
        n(), r(e);
      });
    }),
        n = this.overlay.on(i.MAGIC_HANDLE_EVENT, function (t) {
      var n,
          o = t.data.response;

      if (o.id === e.id && null != (n = o.result) && n.event) {
        var i = o.result,
            s = i.params;
        r.emit.apply(r, [i.event].concat(void 0 === s ? [] : s));
      }
    });
    return r;
  }, c(e, [{
    key: "overlay",
    get: function get() {
      return this.sdk.overlay;
    }
  }]), e;
}(),
    ze = function (t) {
  function r() {
    return t.apply(this, arguments) || this;
  }

  l(r, t);
  var n = r.prototype;
  return n.loginWithMagicLink = function (t) {
    var r = t.showUI,
        n = Ue(this.sdk.testMode ? e.LoginWithMagicLinkTestMode : e.LoginWithMagicLink, [{
      email: t.email,
      showUI: void 0 === r || r,
      redirectURI: t.redirectURI
    }]);
    return this.request(n);
  }, n.loginWithSMS = function (t) {
    var r = Ue(this.sdk.testMode ? e.LoginWithSmsTestMode : e.LoginWithSms, [{
      phoneNumber: t.phoneNumber,
      showUI: !0
    }]);
    return this.request(r);
  }, n.loginWithCredential = function (t) {
    var r = null != t ? t : "";

    if (!t && "web" === ve.platform) {
      r = window.location.search;
      var n = window.location.origin + window.location.pathname;
      window.history.replaceState(null, "", n);
    }

    var o = Ue(this.sdk.testMode ? e.LoginWithCredentialTestMode : e.LoginWithCredential, [r]);
    return this.request(o);
  }, r;
}(Ye);

function Je(e) {
  return function () {
    try {
      var t = arguments,
          r = function r() {
        return Promise.resolve(Be.ready()).then(function () {
          var r;
          return (r = Be)[e].apply(r, [].slice.call(t));
        });
      },
          n = function () {
        if (!Be) return Promise.resolve(ve.configureStorage()).then(function (e) {
          Be = e;
        });
      }();

      return Promise.resolve(n && n.then ? n.then(r) : r(n));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var Qe = Je("getItem"),
    Ze = Je("setItem"),
    et = Je("removeItem"),
    tt = Je("clear"),
    rt = Je("length"),
    nt = Je("key"),
    ot = Je("keys"),
    it = Je("iterate"),
    st = {
  __proto__: null,
  getItem: Qe,
  setItem: Ze,
  removeItem: et,
  clear: tt,
  length: rt,
  key: nt,
  keys: ot,
  iterate: it
};

function at() {
  var e = window.crypto.getRandomValues(new Uint8Array(16));
  e[6] = 15 & e[6] | 64, e[8] = 191 & e[8] | 128;
  var t = "";
  return t += e[0].toString(16), t += e[1].toString(16), t += e[2].toString(16), t += e[3].toString(16), t += "-", t += e[4].toString(16), t += e[5].toString(16), t += "-", t += e[6].toString(16), t += e[7].toString(16), t += "-", t += e[8].toString(16), t += e[9].toString(16), t += "-", t += e[10].toString(16), t += e[11].toString(16), t += e[12].toString(16), t += e[13].toString(16), (t += e[14].toString(16)) + e[15].toString(16);
}

var ct = function ct() {
  try {
    return Promise.resolve(function () {
      try {
        return t = (e = "undefined" != typeof window && !!window.crypto) && !!window.crypto.subtle, e && t ? Promise.resolve(Qe(lt)).then(function (e) {
          function t() {
            return Qe(lt);
          }

          var r = function () {
            if (!e) return Promise.resolve(function () {
              try {
                var e = null,
                    t = window.crypto.subtle;
                return Promise.resolve(t.generateKey(ft, !0, ["sign"])).then(function (r) {
                  return Promise.resolve(t.exportKey("jwk", r.privateKey)).then(function (n) {
                    return Promise.resolve(t.exportKey("jwk", r.publicKey)).then(function (r) {
                      return e = r, Promise.resolve(t.importKey("jwk", n, pt, !1, ["sign"])).then(function (t) {
                        return Promise.resolve(Ze(ut, t)).then(function () {
                          return Promise.resolve(Ze(lt, e)).then(function () {});
                        });
                      });
                    });
                  });
                });
              } catch (e) {
                return Promise.reject(e);
              }
            }()).then(function () {});
          }();

          return r && r.then ? r.then(t) : t();
        }) : (console.info("webcrypto is not supported"), Promise.resolve(void 0));
      } catch (e) {
        return Promise.reject(e);
      }

      var e, t;
    }()).then(function (e) {
      if (e) {
        var t = window.crypto.subtle;
        return Promise.resolve(Qe(ut)).then(function (r) {
          if (r && t) {
            var n,
                o = {
              iat: Math.floor(new Date().getTime() / 1e3),
              jti: at()
            },
                i = vt(JSON.stringify({
              typ: "dpop+jwt",
              alg: "ES256",
              jwk: e
            })),
                s = vt(JSON.stringify(o)),
                a = (n = i + "." + s, new TextEncoder().encode(n));
            return Promise.resolve(t.sign({
              name: ht,
              hash: {
                name: "SHA-256"
              }
            }, r, a)).then(function (e) {
              var t,
                  r,
                  n = (t = new Uint8Array(e), r = "", t.forEach(function (e) {
                r += String.fromCharCode(e);
              }), Et(r));
              return i + "." + s + "." + n;
            });
          }

          console.info("unable to find private key or webcrypto unsupported");
        });
      }

      console.info("unable to create public key or webcrypto is unsupported");
    });
  } catch (e) {
    return Promise.reject(e);
  }
},
    ut = "STORE_KEY_PRIVATE_KEY",
    lt = "STORE_KEY_PUBLIC_JWK",
    ht = "ECDSA",
    ft = {
  name: ht,
  namedCurve: "P-256"
},
    pt = {
  name: ht,
  namedCurve: "P-256"
};

function dt() {
  et(lt), et(ut);
}

function vt(e) {
  return Et(function (e) {
    return encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, function (e, t) {
      return String.fromCharCode(parseInt(t, 16));
    });
  }(e));
}

function Et(e) {
  return btoa(e).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+/g, "");
}

var mt = function (t) {
  function r() {
    return t.apply(this, arguments) || this;
  }

  l(r, t);
  var n = r.prototype;
  return n.getIdToken = function (t) {
    var r = Ue(this.sdk.testMode ? e.GetIdTokenTestMode : e.GetIdToken, [t]);
    return this.request(r);
  }, n.generateIdToken = function (t) {
    var r = Ue(this.sdk.testMode ? e.GenerateIdTokenTestMode : e.GenerateIdToken, [t]);
    return this.request(r);
  }, n.getMetadata = function () {
    var t = Ue(this.sdk.testMode ? e.GetMetadataTestMode : e.GetMetadata);
    return this.request(t);
  }, n.updateEmail = function (t) {
    var r = t.showUI,
        n = Ue(this.sdk.testMode ? e.UpdateEmailTestMode : e.UpdateEmail, [{
      email: t.email,
      showUI: void 0 === r || r
    }]);
    return this.request(n);
  }, n.isLoggedIn = function () {
    var t = Ue(this.sdk.testMode ? e.IsLoggedInTestMode : e.IsLoggedIn);
    return this.request(t);
  }, n.logout = function () {
    dt();
    var t = Ue(this.sdk.testMode ? e.LogoutTestMode : e.Logout);
    return this.request(t);
  }, n.showSettings = function () {
    var t = Ue(this.sdk.testMode ? e.UserSettingsTestMode : e.UserSettings);
    return this.request(t);
  }, r;
}(Ye),
    yt = Ve(),
    gt = yt.createBoundEmitterMethod,
    It = yt.createChainingEmitterMethod,
    wt = function (e) {
  function t() {
    for (var t, r = arguments.length, n = new Array(r), o = 0; o < r; o++) {
      n[o] = arguments[o];
    }

    return (t = e.call.apply(e, [this].concat(n)) || this).isMagic = !0, t.on = It("on", E(t)), t.once = It("once", E(t)), t.addListener = It("addListener", E(t)), t.off = It("off", E(t)), t.removeListener = It("removeListener", E(t)), t.removeAllListeners = It("removeAllListeners", E(t)), t.emit = gt("emit"), t.eventNames = gt("eventNames"), t.listeners = gt("listeners"), t.listenerCount = gt("listenerCount"), t;
  }

  l(t, e);
  var r = t.prototype;
  return r.sendAsync = function (e, t) {
    var r = this;
    if (!t) throw Te({
      procedure: "Magic.rpcProvider.sendAsync",
      argument: 1,
      expected: "function",
      received: null === t ? "null" : _typeof(t)
    });
    if (Array.isArray(e)) this.overlay.post(o.MAGIC_HANDLE_REQUEST, e.map(function (e) {
      var t = Fe(e);
      return r.prefixPayloadMethodForTestMode(t), t;
    })).then(function (e) {
      t(null, e.map(function (e) {
        return u({}, e.payload, {
          error: e.hasError ? new ge(e.payload.error) : null
        });
      }));
    });else {
      var n = Fe(e);
      this.prefixPayloadMethodForTestMode(n), this.overlay.post(o.MAGIC_HANDLE_REQUEST, n).then(function (e) {
        t(e.hasError ? new ge(e.payload.error) : null, e.payload);
      });
    }
  }, r.send = function (e, t) {
    if ("string" == typeof e) {
      var r = Ue(e, Array.isArray(t) ? t : []);
      return this.request(r);
    }

    if (!Array.isArray(e) && !t) {
      var n = Se();
      return n.log(), new Xe(e).applyError({
        code: -32603,
        message: n.rawMessage
      }).payload;
    }

    this.sendAsync(e, t);
  }, r.enable = function () {
    var e = Ue("eth_accounts");
    return this.request(e);
  }, r.request = function (t) {
    return this.prefixPayloadMethodForTestMode(t), e.prototype.request.call(this, t);
  }, r.prefixPayloadMethodForTestMode = function (e) {
    this.sdk.testMode && (e.method = "testMode/eth/" + e.method);
  }, t;
}(Ye);

function Rt(e, t) {
  return t ? new URL(e, t) : new URL(e);
}

var Ot = ["request", "overlay", "sdk"],
    _t = function (e) {
  function t() {
    var t;
    (t = e.call(this, void 0) || this).__sdk_access_field_descriptors__ = new Map(), t.__is_initialized__ = !1, t.utils = {
      createPromiEvent: Ke,
      isPromiEvent: qe,
      encodeJSON: se,
      decodeJSON: ae,
      createJsonRpcRequestPayload: Ue,
      standardizeJsonRpcRequestPayload: Fe,
      storage: st
    };
    var r = [E(t)].concat(function (e) {
      for (var t = Object.getPrototypeOf(e), r = [t]; t !== Ye.prototype;) {
        t = Object.getPrototypeOf(t), r.push(t);
      }

      return r;
    }(E(t)));
    return Ot.forEach(function (e) {
      var n = r.map(function (t) {
        return Object.getOwnPropertyDescriptor(t, e);
      }),
          o = n.findIndex(function (e) {
        return !!e;
      }),
          i = n[o];
      i && (t.__sdk_access_field_descriptors__.set(e, {
        descriptor: i,
        isPrototypeField: o > 0
      }), Object.defineProperty(E(t), e, {
        configurable: !0,
        get: function get() {
          throw Ne(e);
        }
      }));
    }), t;
  }

  l(t, e);
  var r = t.prototype;
  return r.init = function (e) {
    var t = this;
    this.__is_initialized__ || (Ot.forEach(function (e) {
      if (t.__sdk_access_field_descriptors__.has(e)) {
        var r = t.__sdk_access_field_descriptors__.get(e),
            n = r.descriptor;

        r.isPrototypeField ? delete t[e] : Object.defineProperty(t, e, n);
      }
    }), this.sdk = e, this.__is_initialized__ = !0);
  }, r.createDeprecationWarning = function (e) {
    var t = e.useInstead;
    return new Re(this, "DEPRECATION_NOTICE", "`" + e.method + "` will be removed from this Extension in version `" + e.removalVersion + "`." + (t ? " Use `" + t + "` instead." : ""));
  }, r.createWarning = function (e, t) {
    return new Re(this, e, t);
  }, r.createError = function (e, t, r) {
    return new we(this, e, t, r);
  }, t;
}(Ye),
    Lt = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }

  return l(t, e), t;
}(_t),
    Nt = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }

  return l(t, e), t;
}(_t);

function At(e) {
  return !e.compat || null == e.compat[ve.sdkName] || ("string" == typeof e.compat[ve.sdkName] ? function (e, t, r) {
    try {
      t = new C(t, void 0);
    } catch (e) {
      return !1;
    }

    return t.test(e);
  }(function (e, t) {
    if (e instanceof A) return e;
    if ("number" == typeof e && (e = String(e)), "string" != typeof e) return null;
    var r = null;

    if ((t = t || {}).rtl) {
      for (var n; (n = re[ne.COERCERTL].exec(e)) && (!r || r.index + r[0].length !== e.length);) {
        r && n.index + n[0].length === r.index + r[0].length || (r = n), re[ne.COERCERTL].lastIndex = n.index + n[1].length + n[2].length;
      }

      re[ne.COERCERTL].lastIndex = -1;
    } else r = e.match(re[ne.COERCE]);

    return null === r ? null : function (e, t) {
      if (t && "object" == _typeof(t) || (t = {
        loose: !!t,
        includePrerelease: !1
      }), e instanceof A) return e;
      if ("string" != typeof e) return null;
      if (e.length > Z) return null;
      if (!(t.loose ? ee[te.LOOSE] : ee[te.FULL]).test(e)) return null;

      try {
        return new A(e, t);
      } catch (e) {
        return null;
      }
    }(r[2] + "." + (r[3] || "0") + "." + (r[4] || "0"), t);
  }(ve.version), e.compat[ve.sdkName]) : !!e.compat[ve.sdkName]);
}

function Tt(e) {
  var t,
      r = this,
      n = null != (t = null == e ? void 0 : e.extensions) ? t : [],
      o = {},
      i = [];
  if (Array.isArray(n) ? n.forEach(function (e) {
    At(e) ? (e.init(r), (e.name || e.name !== Nt.Anonymous) && (r[e.name] = e), e instanceof Nt.Internal && (de(e.config) || (o[e.name] = e.config))) : i.push(e);
  }) : Object.keys(n).forEach(function (e) {
    if (At(n[e])) {
      n[e].init(r);
      var t = n[e];
      r[e] = t, t instanceof Nt.Internal && (de(t.config) || (o[n[e].name] = t.config));
    } else i.push(n[e]);
  }), i.length) throw Ae(i);
  return o;
}

Nt.Internal = Lt, Nt.Anonymous = "anonymous extension";

var Pt = function () {
  function e(e, t) {
    var r;
    if (this.apiKey = void 0, this.endpoint = void 0, this.parameters = void 0, this.testMode = void 0, this.auth = void 0, this.user = void 0, this.rpcProvider = void 0, this.apiKey = e, !e) throw Oe();
    "react-native" === ve.platform && null != t && t.endpoint && be().log();
    var n = ve.defaultEndpoint,
        o = ve.version;
    this.testMode = !(null == t || !t.testMode), this.endpoint = Rt(null != (r = null == t ? void 0 : t.endpoint) ? r : n).origin, this.auth = new ze(this), this.user = new mt(this), this.rpcProvider = new wt(this);
    var i = Tt.call(this, t);
    this.parameters = se({
      API_KEY: this.apiKey,
      DOMAIN_ORIGIN: window.location ? window.location.origin : "",
      ETH_NETWORK: null == t ? void 0 : t.network,
      host: Rt(this.endpoint).host,
      sdk: me[ve.sdkName],
      version: o,
      ext: de(i) ? void 0 : i,
      locale: (null == t ? void 0 : t.locale) || "en_US"
    });
  }

  return e.prototype.preload = function () {
    try {
      return Promise.resolve(this.overlay.ready).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  }, c(e, [{
    key: "overlay",
    get: function get() {
      if (!e.__overlays__.has(this.parameters)) {
        var t = new ve.ViewController(this.endpoint, this.parameters);
        t.init(), e.__overlays__.set(this.parameters, t);
      }

      return e.__overlays__.get(this.parameters);
    }
  }]), e;
}();

Pt.__overlays__ = new Map();

var St = function () {
  function e(e, t) {
    this.endpoint = void 0, this.parameters = void 0, this.ready = void 0, this.messageHandlers = new Set(), this.endpoint = e, this.parameters = t, this.ready = this.waitForReady(), this.listen();
  }

  var t = e.prototype;
  return t.post = function (e, t) {
    try {
      var r = this;
      return Promise.resolve(We(function (n) {
        try {
          return Promise.resolve(r.ready).then(function () {
            var o = [],
                s = Array.isArray(t) ? t.map(function (e) {
              return e.id;
            }) : [];
            return Promise.resolve(function (e, t) {
              try {
                return Promise.resolve(Qe("rt")).then(function (r) {
                  function n() {
                    return o ? r ? {
                      msgType: e,
                      payload: t,
                      jwt: o,
                      rt: r
                    } : {
                      msgType: e,
                      payload: t,
                      jwt: o
                    } : {
                      msgType: e,
                      payload: t
                    };
                  }

                  var o,
                      i = function () {
                    if ("web" === ve.platform) {
                      var e = function (e, t) {
                        try {
                          var r = Promise.resolve(ct()).then(function (e) {
                            o = e;
                          });
                        } catch (e) {
                          return t(e);
                        }

                        return r && r.then ? r.then(void 0, t) : r;
                      }(0, function (e) {
                        console.error("webcrypto error", e);
                      });

                      if (e && e.then) return e.then(function () {});
                    }
                  }();

                  return i && i.then ? i.then(n) : n();
                });
              } catch (e) {
                return Promise.reject(e);
              }
            }(e + "-" + r.parameters, t)).then(function (e) {
              return Promise.resolve(r._post(e)).then(function () {
                var e,
                    a = r.on(i.MAGIC_HANDLE_RESPONSE, (e = function e() {
                  return a();
                }, function (r) {
                  var i = function (e, t) {
                    var r,
                        n = null == (r = t.data.response) ? void 0 : r.id,
                        o = function (e, t) {
                      return t && Array.isArray(e) ? e.find(function (e) {
                        return e.id === t;
                      }) : e;
                    }(e, n);

                    return n && o ? {
                      id: n,
                      response: new Xe(o).applyResult(t.data.response.result).applyError(t.data.response.error)
                    } : {};
                  }(t, r),
                      a = i.id,
                      c = i.response;

                  !function (e) {
                    try {
                      e.data.rt ? Promise.resolve(Ze("rt", e.data.rt)).then(function () {}) : Promise.resolve();
                    } catch (e) {
                      return Promise.reject(e);
                    }
                  }(r), a && c && Array.isArray(t) && s.includes(a) ? (o.push(c), o.length === t.length && (e(), n(o))) : a && c && !Array.isArray(t) && a === t.id && (e(), n(c));
                }));
              });
            });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, t.on = function (e, t) {
    var r = this,
        n = t.bind(window),
        o = function o(t) {
      t.data.msgType === e + "-" + r.parameters && n(t);
    };

    return this.messageHandlers.add(o), function () {
      return r.messageHandlers.delete(o);
    };
  }, t.waitForReady = function () {
    var e = this;
    return new Promise(function (t) {
      e.on(i.MAGIC_OVERLAY_READY, function () {
        return t();
      });
    });
  }, t.listen = function () {
    var e = this;
    this.on(i.MAGIC_HIDE_OVERLAY, function () {
      e.hideOverlay();
    }), this.on(i.MAGIC_SHOW_OVERLAY, function () {
      e.showOverlay();
    });
  }, e;
}();

export { Nt as Extension, we as MagicExtensionError, Re as MagicExtensionWarning, ge as MagicRPCError, ye as MagicSDKError, Ie as MagicSDKWarning, Pt as SDKBase, ut as STORE_KEY_PRIVATE_KEY, lt as STORE_KEY_PUBLIC_JWK, He as TypedEmitter, St as ViewController, dt as clearKeys, Me as createDeprecationWarning, Pe as createDuplicateIframeWarning, Ne as createExtensionNotInitializedError, Ae as createIncompatibleExtensionsError, Te as createInvalidArgumentError, ct as createJwt, Le as createMalformedResponseError, Oe as createMissingApiKeyError, _e as createModalNotReadyError, Ke as createPromiEvent, We as createPromise, be as createReactNativeEndpointConfigurationWarning, Ee as createSDK, Se as createSynchronousWeb3MethodWarning, Ve as createTypedEmitter, Rt as createURL, ae as decodeJSON, se as encodeJSON, ke as getPayloadId, de as isEmpty, pe as isJsonRpcErrorCode, le as isJsonRpcRequestPayload, he as isJsonRpcResponsePayload, fe as isMagicPayloadMethod, qe as isPromiEvent, st as storage, at as uuid };